/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderPopupstockcodesCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderPopupstockcodesCtrl', ["$scope", "StockItems", "stockSupplierId", function($scope, StockItems, stockSupplierId) {
  $scope.selected = null;

  $scope.searchPhrase = '';

  $scope.searchStockcodes = function() {
    $scope.results = StockItems.searchStockcodes($scope.searchPhrase, stockSupplierId, 200);
  };

  $scope.searchStockcodes();
}]);
